import React from 'react';
import { Card, Table, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import styles from '../ModelDetail.module.scss';
import { GetAiModelDetailResponseData } from '@manifest-cyber/types/interface/contracts/model-analysis/get.contract';


interface DependenciesTableProps {
  modelData: GetAiModelDetailResponseData;
}


export const DependenciesTable: React.FC<DependenciesTableProps> = ({ modelData }) => {
  const { t } = useTranslation();

  return (
    <Card shadow="sm" padding="lg" mt={"xl"} withBorder className={styles.cardContainer}>
      <Title order={3} mb="md">
        {t('mosaic.modelDetail.dependencies.title')}
      </Title>
      <Table>
        <thead>
          <tr>
            <th className={styles.tableHead}>
              {t('mosaic.modelDetail.dependencies.columns.library')}
            </th>
            <th className={styles.tableHead}>
              {t('mosaic.modelDetail.dependencies.columns.version')}
            </th>
            <th className={styles.tableHead}>
              {t('mosaic.modelDetail.dependencies.columns.foundIn')}
            </th>
          </tr>
        </thead>
        <tbody>
          {modelData.softwareDependencies?.map((dep, index) => (
            <tr key={index}>
              <td>{dep.library || t('global.unknown')}</td>
              <td>{dep.version || t('global.unknown')}</td>
              <td>{dep.foundIn || t('global.unknown')}</td>
            </tr>
          ))}
          {(!modelData.softwareDependencies || modelData.softwareDependencies.length === 0) && (
            <tr>
              <td
                colSpan={3}
                style={{ textAlign: 'center', padding: '40px', fontSize: '19px' }}
              >
                {t('mosaic.modelDetail.dependencies.noDependencies')}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </Card>
  );
};
